import { useState } from "react";
import Tabs from "../../components/Tabs";
import AquaZoneSlotTab from "../../components/AquaZone/AquaZoneSlotTab";
import AquaZoneReportTab from "../../components/AquaZone/AquaZoneReportTab";
import AquaZoneHeader from "../../components/AquaZone/AquaZoneHeader";

const AquaZone = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <>
      <AquaZoneHeader />
      <Tabs
        tabHeaderList={[
          { label: "Slot Management", value: 0 },
          { label: "Reports", value: 1 },
        ]}
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
      />
      {selectedTab === 0 && <AquaZoneSlotTab />}
      {selectedTab === 1 && <AquaZoneReportTab />}
    </>
  );
};

export default AquaZone;
